import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import AutoTips from '@/components/AutoTips/index.vue';
import { mapMutations, mapState } from 'vuex';
import { language } from '@/common/storage';
import { dotNotationToBracketNotation } from '@com/utils/string';

/**
 * 获取玩法分类名字
 */
var getGameConfigCategoryName = function getGameConfigCategoryName(category) {
  return language.get() === 'en' ? category.name_en || category.name : category.name;
};

/**
 * 获取玩法分类描述
 */
var getGameConfigCategoryDesc = function getGameConfigCategoryDesc(category) {
  return language.get() === 'en' ? category.desc_en || category.desc : category.desc;
};

export default {
  components: {
    AutoTips: AutoTips
  },

  props: {
    config: {
      type: Object,
      required: true
    },

    prefix: {
      type: String,
      required: true
    },

    editable: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      editing: false,
      formValue: {},
      disabledToolTip: true,
      desc: ''
    };
  },


  computed: _extends({}, mapState({
    playConfig: function playConfig(state) {
      return state.creative.template.templateConfig.play_config;
    }
  }), {
    titleEditable: function titleEditable() {
      return this.editable;
    },
    tooltipAttrs: function tooltipAttrs() {
      return {
        effect: 'dark',
        placement: 'top',
        content: this.formValue.legend,
        disabled: this.disabledToolTip
      };
    },
    formItemList: function formItemList() {
      var validateName = function validateName(rule, value, callback) {
        if (value.length >= 100) {
          callback(new Error('category name length must lt 100'));
        } else {
          callback();
        }
      };

      return {
        legend: {
          prop: 'legend',
          rules: [{
            required: true,
            message: 'category name is required',
            trigger: 'blur'
          }, {
            required: true,
            validator: validateName,
            trigger: 'blur'
          }],
          params: {
            clearable: false
          },
          style: 'margin-bottom: 0'
        }
      };
    },
    innerKeyPath: function innerKeyPath() {
      return dotNotationToBracketNotation(this.prefix);
    }
  }),

  watch: {
    editing: function editing(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.$refs.input && _this.$refs.input.focus();
        }, 100);
      } else {
        this.$nextTick(function () {
          _this.checkIsShowTip();
        });
      }
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.form && _this2.$refs.form.validate && _this2.addValidator({
        name: 'group-legend',
        validate: _this2.$refs.form.validate
      });
    });
    this.getFormValue();
  },


  methods: _extends({}, mapMutations({
    updateTargetPlayConfig: 'creative/template/updateTargetPlayConfig',
    addValidator: 'creative/template/addValidator'
  }), {
    checkIsShowTip: function checkIsShowTip() {
      if (this.$refs.labelText.offsetWidth > 180) {
        this.disabledToolTip = false;
      } else {
        this.disabledToolTip = true;
      }
    },
    getFormValue: function getFormValue() {
      var currentGameConfigConfig = _.get((this.playConfig || {}).gameConfig, '' + this.innerKeyPath);
      var legend = currentGameConfigConfig && getGameConfigCategoryName(currentGameConfigConfig) || this.config.title || this.config.desc;
      var desc = currentGameConfigConfig && getGameConfigCategoryDesc(currentGameConfigConfig) || this.config.desc || this.config.title;
      this.formValue = {
        legend: legend,
        desc: desc
      };
    },
    handleNameChange: function handleNameChange(evt) {
      var _this3 = this;

      this.updateTargetPlayConfig({
        key: this.innerKeyPath,
        value: {
          name: evt.target.value
        }
      });
      // 只有校验通过才隐藏输出框
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this3.editing = false;
        }
      });
    },
    handleDescChange: function handleDescChange(val) {
      this.updateTargetPlayConfig({
        key: this.innerKeyPath,
        value: {
          desc: val
        }
      });
    }
  })
};